import React, { createContext, useContext } from 'react'

const PanelPreviewContext = createContext(false)

// Gallery preview — panels stay look-only (ADR-049).
export const PanelPreviewProvider = ({ children }: { children: React.ReactNode }) => (
  <PanelPreviewContext.Provider value>{children}</PanelPreviewContext.Provider>
)

export const useIsPanelPreview = (): boolean => useContext(PanelPreviewContext)

// For a control that edits or writes: dead in preview, whatever the caller's own reason to disable it.
export const useDisabledInPreview = (disabled?: boolean): boolean => useIsPanelPreview() || Boolean(disabled)
